//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('collection', {
//        templateUrl: 'views/components/views/collection/collection.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'collectionService', function ($stateParams, stateService, modalService, translateService, collectionService) {
//            const vm = this;
//            let collectionKeyno = $stateParams.collection_keyno;

//            let translations = {
//            	error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            async function loadEdit() {
//                vm.model.edit = (await collectionService.getEdit({ collection_keyno: collectionKeyno }))[0];
//            }
            
//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                collectionService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                            }]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            }

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//            }
//        }]
//    });
//})();
